module.exports = __webpack_public_path__ + "34bc775d/img/file-icon.c085e21e.svg";